import { themeStyle } from '@repo/ui/theming';
import styled, { css } from 'styled-components';

import { TextAreaTheme } from './types';

const BasicStyles = css`
  flex: 1;
  width: 100%;
  box-sizing: border-box;

  font-weight: ${({ theme }) => theme.fontWeight};
  font-size: ${({ theme }) => theme.fontSize};
  line-height: ${({ theme }) => theme.lineHeight};
  text-align: ${({ theme }) => theme.textAlign};

  padding: 0 ${({ theme }) => theme.innerPadding};
  margin: 0;
  background: transparent;

  transition: ${({ theme }) => theme.transition};
  transition-property: color;

  font-style: ${({ theme }) => (theme.fontStyle ? theme.fontStyle : 'unset')};

  border-radius: ${({ theme }) => theme.borderRadius};
  border: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme }) => theme.colorActive};

  &:focus {
    outline: none;
  }
`;

export const TextAreaWrapper = styled.div<{
  isTextAreaAutoGrowing?: boolean;
  textAreaMinHeight?: string;
  textAreaMaxHeight?: string;
  theme: TextAreaTheme;
}>`
  display: grid;
  width: 100%;

  ${({ isTextAreaAutoGrowing, textAreaMinHeight, textAreaMaxHeight }) =>
    isTextAreaAutoGrowing &&
    css`
      &:after {
        /* This is how textarea text behaves */
        /* Hidden from view, clicks, and screen readers */
        ${BasicStyles}
        content: attr(data-autogrowing) '&nbsp;';
        visibility: hidden;
        white-space: wrap;
        grid-area: 1 / 1 / 2 / 2;
        padding: 10px;
        box-sizing: border-box;
        ${textAreaMinHeight && `min-height: ${textAreaMinHeight};`}
        ${textAreaMaxHeight && `max-height: ${textAreaMaxHeight};`}
        white-space: pre-line;
        word-break: break-word;
      }
    `}

  > textarea {
    ${BasicStyles}
    resize: none;
    overflow: scroll;
    line-height: 140%;
    grid-area: 1 / 1 / 2 / 2;
    padding: 10px;
    box-sizing: border-box;
    ${({ textAreaMinHeight }) =>
      textAreaMinHeight && `min-height: ${textAreaMinHeight};`}
    ${({ textAreaMaxHeight }) =>
      textAreaMaxHeight && `max-height: ${textAreaMaxHeight};`}
    white-space: pre-line;
    word-break: break-word;

    &::placeholder {
      color: ${themeStyle.varInkMedium};
    }
  }
`;
